import { eApiTags } from './eApiTags';
import { baseFolder } from '../constants';
import { getBaseApi } from 'aspen-spruce';

export const BaseApi = getBaseApi(baseFolder, eApiTags);

export const { useGetEnvVariablesQuery } = BaseApi;
